var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Spacer',{staticClass:"section",style:({
    backgroundColor:
      _vm.layout.background_color !== '' ? ("var(--" + (_vm.layout.background_color)) : null,
  }),attrs:{"id":_vm.layout.section_id ? _vm.layout.section_id : null,"tag":"section","template":("section-" + (_vm.layout.section_spacer))}},[_c('Wrapper',{attrs:{"template":("section-" + (_vm.layout.gap)),"size":_vm.layout.section_wrapper && _vm.layout.section_wrapper !== 'no'
        ? _vm.layout.section_wrapper
        : undefined}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }